import React from "react";
import { connect } from "react-redux";
import { Select } from "evergreen-ui";
import { Popover, Pane, Text, Button, Position, toaster } from "evergreen-ui";
import { useState } from "react";

const CountryCodeSelector = (props) => {
  const { height, countryCodes, selectedCountryCode, changeCountryCode } = props;
  const [showPopover, setShowPopover] = useState(false);

  return (
    <Popover
      isShown={showPopover}
      onOpen={() => setShowPopover(true)}
      onClose={() => setShowPopover(false)}
      content={
        <Pane
          width={"100%"}
          height={320}
          display='flex'
          alignItems='flex-start'
          justifyContent='flex-start'
          flexDirection='column'
          overflow='auto'
        >
          {
            // eslint-disable-next-line
            countryCodes &&
              countryCodes.data.map((country, index) => {
                if (country.callingCode !== "") {
                  const countryCode = `+${country["callingCodes"][0]}`;
                  return (
                    <Pane
                      padding={2}
                      key={index}
                      onClick={() => {
                        document.getElementById("mobile-number").focus();
                        setShowPopover(false);
                        changeCountryCode(countryCode);
                      }}
                    >
                      <Text size={500} marginTop={20}>
                        ({countryCode}) {country.name}
                      </Text>
                    </Pane>
                  );
                }
              })
          }
        </Pane>
      }
      position={Position.BOTTOM_LEFT}
    >
      <Button
       
        height={height || 40}
        width={"34%"}
        onClick={(e) => setShowPopover(true)}
        iconAfter='caret-down'
      >
        {selectedCountryCode}
      </Button>
    </Popover>
    // <Select
    //     height={height || 40}
    //     width={"34%"}
    //     paddingRight={0}
    //     className={"county-code-select"}
    //     value={selectedCountryCode}
    //     onChange={(e) => changeCountryCode(e.target.value)}
    // >
    //     {countryCodes ? countryCodes.data.map((country, index) => {
    //         if (country["callingCodes"] && country["callingCodes"][0] !== "") {
    //             const countryCode = `+${country["callingCodes"][0]}`;
    //             return <option
    //                 key={index}
    //                 value={countryCode}
    //             >
    //                 {countryCode}({country.name})
    //             </option>
    //         }
    //         return <React.Fragment key={index}/>
    //     }) : <React.Fragment/>}
    // </Select>
  );
};

const mapStateToProps = ({ countryCodes }) => ({
  countryCodes,
});

export default connect(mapStateToProps)(CountryCodeSelector);
